import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { useNavigate } from "react-router-dom";

const flagSrc = (code) => `https://flagcdn.com/w80/${code}.png`;

export default function CountriesSection() {
  const { t } = useLang();
  const { content } = useContent();
  const navigate = useNavigate();
  const [tab, setTab] = useState("primary");
  const [selected, setSelected] = useState(null);

  const list =
    tab === "primary"
      ? content?.countries_primary || []
      : content?.countries_secondary || [];

  const onSelect = (code) => {
    setSelected(code);
    setTimeout(() => navigate(`/contact?country=${code}`), 250);
  };

  return (
    <section className="section-pad bg-radial-gold relative" data-testid="countries-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="overline mb-3">{t("countries.overline")}</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4">
            {t("countries.title")}
          </h2>
          <p className="text-white/65 max-w-2xl mx-auto">{t("countries.subtitle")}</p>
        </div>

        <div className="flex justify-center mb-10">
          <div className="inline-flex p-1 rounded-full glass border border-white/10">
            <button
              onClick={() => setTab("primary")}
              data-testid="countries-tab-primary"
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all ${
                tab === "primary"
                  ? "bg-gradient-to-r from-[#4cb2ee] to-[#0d5a8e] text-white shadow-[0_6px_20px_-6px_rgba(30,144,213,0.7)]"
                  : "text-white/70 hover:text-white"
              }`}
            >
              {t("countries.primary")}
            </button>
            <button
              onClick={() => setTab("secondary")}
              data-testid="countries-tab-secondary"
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all ${
                tab === "secondary"
                  ? "bg-gradient-to-r from-[#4cb2ee] to-[#0d5a8e] text-white shadow-[0_6px_20px_-6px_rgba(30,144,213,0.7)]"
                  : "text-white/70 hover:text-white"
              }`}
            >
              {t("countries.secondary")}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {list.map((c, i) => (
            <button
              key={c.code}
              onClick={() => onSelect(c.code)}
              className={`country-card fade-up ${selected === c.code ? "active" : ""}`}
              style={{ animationDelay: `${i * 25}ms` }}
              data-testid={`country-card-${c.code}`}
            >
              <img src={flagSrc(c.code)} alt={c.name} className="flag-img" />
              <span className="text-sm font-medium text-white/90">{c.name}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
